<h2 class="headerTitle">Newsletter</h2>
<div class="line"></div>
<button (click)="onCreate()" pButton [label]="'Utwórz nowy'"></button>
<br/><br/>
<p-table [value]="newsletters" *ngIf="newsletters.length > 0">
  <ng-template pTemplate="header">
      <tr>
          <th class="colTitle" style="width:90%">Temat</th>
          <th class="colTitle" style="width:10%">Opcje</th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-n>
      <tr>
          <td style="width:90%"
             >{{n.subject}}</td>
          <td style="width:10%;cursor: pointer" (click)="onCreate(n.id)">Zmień</td>
      </tr>
  </ng-template>
</p-table>
